import React from 'react';

import OrganizationHeader from '../containers/header/OrganizationHeader';
import OrganizationCover from '../containers/cover/OrganizationCover';
import OrganizationMembers from '../containers/organizationMembers/OrganizationMembers';

import isAuthorizedCurrentOrganization from '../hoc/CurrentOrganizationAuthorization';

const OrganizationMembersPage = () => {
    return (
        <React.Fragment>
            <OrganizationHeader />
            <OrganizationCover />
            <OrganizationMembers />
        </React.Fragment>
    );
};

export default isAuthorizedCurrentOrganization(OrganizationMembersPage);



// WEBPACK FOOTER //
// ./src/pages/OrganizationMembersPage.js